import { render, staticRenderFns } from "./MenuTreePathSelector.vue?vue&type=template&id=a8067834&scoped=true&"
import script from "./MenuTreePathSelector.vue?vue&type=script&lang=ts&"
export * from "./MenuTreePathSelector.vue?vue&type=script&lang=ts&"
import style1 from "./MenuTreePathSelector.vue?vue&type=style&index=1&id=a8067834&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8067834",
  null
  
)

export default component.exports